<template>
    <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
        <template v-for="(item, index) in breadcrumb">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted" v-if="index < breadcrumbLenght">
                <Link :href="this.route(item.link)" class="text-muted text-hover-primary">{{item.title}}</Link >
            </li>
            <li class="breadcrumb-item text-dark" v-else>
                {{item.title}}
            </li>
            <!--end::Item-->
            <li class="breadcrumb-item" v-if="index < breadcrumbLenght">
                <span class="bullet bg-gray-300 w-5px h-2px"></span>
            </li>
        </template>
    </ul>
</template>

<script>
import {Link} from "@inertiajs/inertia-vue3";

export default {
    components: {
        Link
    },
    props: {
        breadcrumb: {
            type: Array,
            required: true,
        }
    },
    computed: {
        breadcrumbLenght() {
            return this.breadcrumb.length - 1;
        },

        activeClass() {
            return 'text-dark';
        },

        normalClass() {
            return 'text-muted';
        }
    }
}
</script>
